module.exports = __webpack_public_path__ + "img/pen-icon.774fd7d9.png";